document.addEventListener('DOMContentLoaded', function() {
  var accordion = document.querySelectorAll('[data-accordion]');

  accordion.forEach(function(item) {
    item.querySelectorAll('[data-accordion-title]').forEach(function(title) {
      title.addEventListener('click', function(e) {
        e.preventDefault();

        const content = title.nextElementSibling;

        if (content.hasAttribute('data-accordion-content')) {
          content.classList.toggle('tw-h-0');


          const chevron_icon = title.querySelector('[data-accordion-icon]');

          if (chevron_icon) {
            chevron_icon.classList.toggle('tw-rotate-180');
          }
        }
      });
    });
  });
});